/**
 * @generated SignedSource<<bb3eb85ef07bc505facd04fb937160b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SelectAddableClientsDialog_clients$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly displayName: string | null | undefined;
      readonly email: string | null | undefined;
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"ClientAddableItem_client">;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "SelectAddableClientsDialog_clients";
};
export type SelectAddableClientsDialog_clients$key = {
  readonly " $data"?: SelectAddableClientsDialog_clients$data;
  readonly " $fragmentSpreads": FragmentRefs<"SelectAddableClientsDialog_clients">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SelectAddableClientsDialog_clients",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ClientEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "email",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ClientAddableItem_client"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ClientConnection",
  "abstractKey": null
};

(node as any).hash = "55dbd93a4377ac880da38053e610894a";

export default node;
